<div class="white-bg">
  <breadcrumbs>
    <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="pageTitle | translate | async"></breadcrumb>
  </breadcrumbs>
  <div class="content">
    <div class="overview">
      <div class="overview__image-container">
        <div class="overview__image" *ngIf="!loadingEquipment" [style.width.px]="size" [@fadeIn]>
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
        </div>
      </div>
      <div class="overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="translate('Serial Number')" [primary]="true" [loading]="loadingEquipment">
              <a routerLink="/equipment/{{equipmentId}}" [matTooltip]="translate('Manage Equipment')">{{ equipmentDetails.SerialNumber }}</a>
            </item>
            <item [label]="translate('Unit Number')" [primary]="true" [loading]="loadingEquipment">
              <a routerLink="/equipment/{{equipmentId}}" [matTooltip]="translate('Manage Equipment')" >{{ equipmentDetails.UnitNumber }}</a>
            </item>

            <item [label]="translate('Additional Unit Number')"  [primary]="true" [loading]="loadingEquipment" *ngIf="equipmentDetails.AdditionalUnitNo!=null">
              {{ equipmentDetails.AdditionalUnitNo }}
            </item>
            <!--
              <item [label]="translate('Make')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Make}}</item>
              <item [label]="translate('Model')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Model}}</item>
            -->
          </item-group>
          <div  class="content__primary-buttons"  *ngIf="!loadingEquipment"  [@fadeInList] >
            <button mat-raised-button color="warn" (click)="changeEquipment()">
              <i class="material-icons button__icon">cached</i>
              {{ translate("Change Equipment") }}
            </button>
          </div>
        </div>
        <div class="content__secondary">
          <div class="special">
            <item-group>
              <div>
                <item [label]="translate('Customer')" [loading]="loadingEquipment" >{{ equipmentDetails.CustomerName }}</item>
              </div>
              <div>
                <item [label]="translate('Job Site')" [loading]="loadingEquipment">{{ equipmentDetails.JobsiteName }}</item>
              </div>
              <div>
                <item [label]="translate('Meter Reading (SMU/Hourmeter)')" [loading]="loadingEquipment">{{ equipmentDetails.Smu }}</item>
              </div>
              <div>
                <item [label]="translate('Life to Date (LTD)')" [loading]="loadingEquipment">{{ equipmentDetails.Ltd }}</item>
              </div>
              <div>
                <item [label]="translate('Make')" [loading]="loadingEquipment" >{{ equipmentDetails.Make }}</item>
              </div>
              <div>
                <item [label]="translate('Model')" [loading]="loadingEquipment">{{ equipmentDetails.Model }}</item>
              </div>
              <div>
                <item [label]="translate('Family')" [loading]="loadingEquipment">{{ equipmentDetails.Family }}</item>
              </div>
              <div></div>
            </item-group>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel__background">
    <mat-horizontal-stepper linear="true" #stepper>
      <mat-step  [stepControl]="GeneralInfoGroup">
        <ng-template matStepLabel>{{   "General Information" | translate | async  }}</ng-template>
        <form novalidate [formGroup]="GeneralInfoGroup">
          <div class="flex flex-containers">
            <div class="panel info-panels ">
              <div class="panel__header">
                <span class="panel__header__title">
                  {{ "Equipment Hours" | translate | async }}
                </span>
              </div>
              <div>
                <item-group>
                  <item style="margin-left: 15px; margin-right: 0px; margin-top: 15px; margin-bottom: 15px;" [loading]="overviewIsLoading">
                    
                      <div class="input-grouping">
                        <span class="input-grouping__side">{{"Meter Reading(SMU/Hourmeter) * " | translate | async }}</span>
                        <span class="input-grouping__reading">
                          <input class="input-travel inspectionSMUInput"  type="number" formControlName="smuReading" [(ngModel)]="inspection.SMUReading" 
                          (ngModelChange)="validationOne($event)" /> Hrs
                        </span>

                        <span>
                          <condition-photo [photo]="inspection.SMUImages" 
                          [condition]="Condition.SMUImageHour" [inspectionId]="inspection?.InspectionId" [equipmentId] ="equipmentId" [isImageUrl]="true" [isEquipmentSmuHrs]="true"
                          (photoChange)="reloadObservations(Condition.SMUImageHour, $event)"></condition-photo>
                        </span>

                   
                      </div>
  
                     
                   
                    
                    <div class="input-grouping" *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1" >
                      <span class="input-grouping__side">{{ "Forward Travel hrs" | translate | async }}</span>
                      <span class="input-grouping__reading">
                        <input class="input-travel"  type="number"  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          formControlName="ForwardTravelHours"  [(ngModel)]="inspection?.TravelProperties.ForwardTravelHr" />  Hrs
                      </span>
                    </div>
                    <div class="input-grouping" *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1">
                      <span class="input-grouping__side">{{ "Forward Travel" | translate | async }}</span>
                      <span class="input-grouping__reading">
                        <input class="input-travel" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" (focusout)="calculateTotalDistance()"
                           formControlName="ForwardTravelKms" [(ngModel)]="inspection?.TravelProperties.ForwardTravelKm"/> {{measurementDistance}}
                      </span>
                    </div>

                    <div class="input-grouping" *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1">
                      <span class="input-grouping__side">{{ "Total Dist." | translate | async }}</span>
                      <span class="input-grouping__reading"> {{totalInspDistance}} {{measurementDistance}}
                     
                      </span>
                    </div>
                   
                  </item>

                  <item style="margin-left: 15px; margin-right: 0px; margin-top: 15px; margin-bottom: 15px;"   [loading]="overviewIsLoading" >
                    <div class="input-grouping" *ngIf="equipmentDetails.ShowPropelHrsPerc && isBasicUser==1">
                      <span class="input-grouping__side">{{"Propel Hours * " | translate | async }}</span>
                      <span class="input-grouping__reading">
                        <input class="input-travel inspectionSMUInput"  type="number" formControlName="pmuReading" [(ngModel)]="inspection.PMUReading" /> Hrs
                      </span>
                    </div>

                    <div class="input-grouping">
                      <span class="input-grouping__side">{{ "Inspection Date *" | translate | async }}</span>
                      <span class="input-grouping__reading">
                        <input class="input-travel" min="{{equipmentDetails?.EquipmentSetupDate | date:'yyyy-MM-dd'}}" (click)="picker.open()" readonly [matDatepicker]="picker" placeholder="Choose a date"
                              formControlName="inspectionDate" max="{{ todate | date:'yyyy-MM-dd'}}"  [(ngModel)]="inspection.InspectionDate" />
                        <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </span>
                    </div>

                    <div class="input-grouping" *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1">
                      <span class="input-grouping__side" style="margin-top: -4%;">{{ "Reverse Travel hrs" | translate | async }}</span>
                      <span class="input-grouping__reading">
                        <input class="input-travel" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57" 
                          formControlName="ReverseTravelHours" [(ngModel)]="inspection?.TravelProperties.ReverseTravelHr" /> Hrs
                      </span>
                    </div>
                    <div class="input-grouping" *ngIf="!equipmentDetails.ShowPropelHrsPerc && isBasicUser==1">
                      <span class="input-grouping__side" style="margin-top: -4%;">{{ "Reverse Travel" | translate | async }}</span>
                      <span class="input-grouping__reading">
                        <input class="input-travel" type="number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"  (focusout)="calculateTotalDistance()"
                          formControlName="ReverseTravelKms" [(ngModel)]="inspection?.TravelProperties.ReverseTravelKm" /> {{measurementDistance}}
                      </span>
                    </div>
                  </item>
                </item-group>
              </div>
            </div>

            <div class="panel  info-panels">
              <div class="panel__header">
                <span class="panel__header__title">
                  {{ "Overall Notes" | translate | async }}
                </span>
              </div>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap; ">

              
              <div style="display:block; height : 150px;">
                <span class="inspection-notes-label">
                  {{ "Inspection Notes" | translate | async }}
                </span>
                <span>
                  <textarea class="inspection-notes-textArea" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  formControlName="InspectionNotes" [(ngModel)]="inspection.InspectionNotes" ></textarea>
                </span>
              </div>
              <div style="display:block; height : 150px;">
                <span class="inspection-notes-label">
                  {{ "Jobsite Notes" | translate | async }}
                </span>
                <span>
                    <!-- [ngModelOptions]="{ standalone: true }" -->
                 <textarea class="inspection-notes-textArea" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" formControlName="JobsiteNotes" [(ngModel)]="inspection.JobsiteNotes" ></textarea>
                </span>
              </div>

              <div style="display:block; height : 150px; padding-left: 50px;">
                <span class="inspection-notes-label" style="margin-left: 0px !important;">
                  {{ "Work Order#" | translate | async }}
                </span>
                <span>
                 <input class="input-travel" style="width:160px;text-align: left !important;" type="text" formControlName="workOrder" [(ngModel)]="inspection.WorkOrder" />
                </span>
              </div>
            </div>
            </div>
          </div>
          <div class="flex flex-containers">
            <div class="panel info-panels " style="width: 50%;">
              <div class="panel__header">
                <span class="panel__header__title">
                  {{ "Underfoot Conditions" | translate | async }}
                </span>
              </div>
              <div *ngIf="showUnderFootConditions;else noUnderfootConditions" >
                <div class="conditions-row">
                  <span>
                    <div class="conditions-label">
                      {{ "Impact *" | translate | async }}
                    </div>
                  </span>
                  <mat-radio-group formControlName="impact" [(ngModel)]="inspection?.UnderfootConditions.Impact"  ngDefaultControl required >
                    <mat-radio-button class="conditons-radio-buttons" *ngFor="let condition of underfootConditions" [value]="condition.value" >
                      {{ condition.Title | translate | async }}
                    </mat-radio-button>
                  </mat-radio-group>
                  <div *ngIf="impact?.errors && (impact?.dirty || impact?.touched)" style="margin-bottom: 20px;" >
                    <mat-error *ngIf="impact?.errors.min">{{ "Old SMU/Hourmeter must be greater than previous SMU/Hourmeter" | translate | async }}</mat-error>
                  </div>
                </div>
                <div class="conditions-row">
                  <span>
                    <div class="conditions-label">
                      {{ "Abrasive *" | translate | async }}
                    </div>
                  </span>
                  <span>
                    <mat-radio-group formControlName="abrasive" [(ngModel)]="inspection?.UnderfootConditions.Abrasive" ngDefaultControl required >
                      <mat-radio-button class="conditons-radio-buttons" *ngFor="let condition of underfootConditions" [value]="condition.value" >
                        {{ condition.Title | translate | async  }}
                      </mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="abrasive?.errors && (abrasive?.dirty || abrasive?.touched)" style="margin-bottom: 20px;" >
                      <mat-error *ngIf="abrasive?.errors.min">{{ "Please Select Moisture" | translate | async }}</mat-error>
                    </div>
                  </span>
                </div>
                <div class="conditions-row">
                  <span>
                    <div class="conditions-label">
                      {{ "Moisture *" | translate | async }}
                    </div>
                  </span>
                  <span>
                    <mat-radio-group formControlName="moisture" [(ngModel)]="inspection?.UnderfootConditions.Moisture" ngDefaultControl required>
                      <mat-radio-button class="conditons-radio-buttons" *ngFor="let condition of underfootConditions" [value]="condition.value">
                        {{ condition.Title | translate | async  }}
                      </mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="moisture?.errors && (moisture?.dirty || moisture?.touched)" style="margin-bottom: 20px;">
                      <mat-error *ngIf="moisture?.errors.min"> {{ "Please Select Moisture" | translate | async}} </mat-error>
                    </div>
                  </span>
                </div>
                <div class="conditions-row" style="margin-bottom:20px;">
                  <span>
                    <div class="conditions-label">
                      {{ "Packing *" | translate | async }}
                    </div>
                  </span>
                  <span>
                    <mat-radio-group formControlName="packing" [(ngModel)]="inspection?.UnderfootConditions.Packing" ngDefaultControl required >
                      <mat-radio-button class="conditons-radio-buttons" *ngFor="let condition of underfootConditions"  [value]="condition.value" >
                        {{ condition.Title  | translate | async }}
                      </mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="packing?.errors && (packing?.dirty || packing?.touched)" style="margin-bottom: 20px;" >
                      <mat-error *ngIf="packing?.errors.min"> {{ "Please Select Packing" | translate | async }}</mat-error>
                    </div>
                  </span>
                </div>
              </div>
              <ng-template #noUnderfootConditions><div style="padding: 20px;"><span >{{ "No Underfoot Conditions active for this family" | translate | async }}</span></div> </ng-template>
            </div>

            <div class="panel  info-panels" *ngIf="showUCCondition" style="width: 50%;">
              <div class="panel__header">
                <span class="panel__header__title">
                  {{ "Observations" | translate | async }}
                </span>
              </div>
           
            
              <div >
                
                <item-group  >
                  <!-- might be able to do this in a ngfor -->
                  
                  <item  *ngIf="visibility('TS') && showTrackSag" style="margin-left: 15px; margin-right: 0px;" [label]="translate('Track Sag')" [loading]="overviewIsLoading"  >
                    <div class="condition">
                      <span class="condition__side">L</span>
                      <span class="condition__reading">
                        <input [ngClass]="GetBorderColour(inspection.ObservationReadings.TrackSagL,'TS')" class="input-readings" type="number" formControlName="TrackSagLeft" [(ngModel)]="inspection.ObservationReadings.TrackSagL" /> {{measurementUnit}}
                      </span>
                      <i *ngIf="inspection.ObservationComments.TrackSagLComment !== '' || inspection.ObservationComments.TrackSagLComment !== spaceComment  "
                      [matTooltip]="inspection.ObservationComments.TrackSagLComment == '' ? 'Add Comment' :inspection.ObservationComments.TrackSagLComment"
                      class="material-icons condition__icon" [class.has-comment]="inspection.ObservationComments.TrackSagLComment!== null && inspection.ObservationComments.TrackSagLComment!== undefined&& inspection.ObservationComments.TrackSagLComment !== ' '&& inspection.ObservationComments.TrackSagLComment !== ''"
                      (click)="openConditionComment(Condition.TrackSagL, inspection.ObservationComments.TrackSagLComment)">
                      chat_bubble{{ inspection.ObservationComments.TrackSagLComment!== null && inspection.ObservationComments.TrackSagLComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.TrackSagLImage"  [isImagePathRequired]="true" 
                      [condition]="Condition.TrackSagL" [inspectionDraftId] ="inspection.InspectionId"  [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.TrackSagL, $event)"></condition-photo>
                    </div>
                    <div class="condition">
                      <span class="condition__side">R</span>
                      <span class="condition__reading">
                        <div>
                          <input [ngClass]="GetBorderColour(inspection.ObservationReadings.TrackSagR,'TS')" class="input-readings"  type="number" formControlName="TrackSagRight"   
                          [(ngModel)]="inspection.ObservationReadings.TrackSagR" /> {{measurementUnit}}
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.TrackSagRComment !== ''  || inspection.ObservationComments.TrackSagRComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.TrackSagRComment == '' ? 'Add Comment' :inspection.ObservationComments.TrackSagRComment"
                      class="material-icons condition__icon" [class.has-comment]="inspection.ObservationComments.TrackSagRComment !== null && inspection.ObservationComments.TrackSagRComment !== undefined && inspection.ObservationComments.TrackSagRComment !== ' '&& inspection.ObservationComments.TrackSagRComment !== ''"
                      (click)="openConditionComment(Condition.TrackSagR, inspection.ObservationComments.TrackSagRComment)">
                      chat_bubble{{ inspection.ObservationComments.TrackSagRComment !== null && inspection.ObservationComments.TrackSagRComment !== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo [photo]="inspection.ObservationImages.TrackSagRImage"  [isImagePathRequired]="true" 
                      [condition]="Condition.TrackSagR" [inspectionDraftId]="inpsectionDraftId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.TrackSagR, $event)"></condition-photo>
                   
                    </div>
                  </item>
                  <item *ngIf="visibility('CE') && showCannonExt" style="margin-left: 15px;margin-right: 0px;" [label]="translate('Cannon Ext.')" [loading]="overviewIsLoading">
                    <div class="condition">
                      <span class="condition__side">L</span>
                      <span class="condition__reading">
                        <div>
                          <input [ngClass]="GetBorderColour(inspection.ObservationReadings.CannonExtL,'CE')" class="input-readings"  type="number"  formControlName="CannonExtLeft" [(ngModel)]="inspection.ObservationReadings.CannonExtL"/> {{measurementUnit}}
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.CannonExtLComment !== ''  || inspection.ObservationComments.CannonExtLComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.CannonExtLComment == '' ? 'Add Comment' :inspection.ObservationComments.CannonExtLComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.CannonExtLComment!== null  &&inspection.ObservationComments.CannonExtLComment!== undefined && inspection.ObservationComments.CannonExtLComment !== ' '&& inspection.ObservationComments.CannonExtLComment !== ''"
                      (click)="openConditionComment(Condition.CannonExtL, inspection.ObservationComments.CannonExtLComment)">
                      chat_bubble{{ inspection.ObservationComments.CannonExtLComment!== null  &&inspection.ObservationComments.CannonExtLComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.CannonExtLImage" [isImagePathRequired]="true" 
                      [condition]="Condition.CannonExtL" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.CannonExtL, $event)"></condition-photo>
                    </div>
                    <div class="condition">
                      <span class="condition__side">R</span>
                      <span class="condition__reading">
                        <div>
                          <input  [ngClass]="GetBorderColour(inspection.ObservationReadings.CannonExtR,'CE')" class="input-readings" type="number" formControlName="CannonExtRight"  [(ngModel)]="inspection.ObservationReadings.CannonExtR"/> {{measurementUnit}}
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.CannonExtRComment !== '' || inspection.ObservationComments.CannonExtRComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.CannonExtRComment == '' ? 'Add Comment' :inspection.ObservationComments.CannonExtRComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.CannonExtRComment!== null  &&inspection.ObservationComments.CannonExtRComment!== undefined && inspection.ObservationComments.CannonExtRComment !== ' '&& inspection.ObservationComments.CannonExtRComment !== ''"
                      (click)="openConditionComment(Condition.CannonExtR, inspection.ObservationComments.CannonExtRComment)">
                      chat_bubble{{ inspection.ObservationComments.CannonExtRComment!== null  &&inspection.ObservationComments.CannonExtRComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.CannonExtRImage" [isImagePathRequired]="true" 
                      [condition]="Condition.CannonExtR" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.CannonExtR, $event)"></condition-photo>
                    </div>
                  </item>

                  <item *ngIf="isBasicUser==1 && visibility('S') && showScallop" style="margin-left: 15px;margin-right: 0px;" [label]="translate('Scallop')" [loading]="overviewIsLoading" >
                    <div class="condition">
                      <span class="condition__side">L</span>
                      <span class="condition__reading">
                        <div>
                          <input [ngClass]="GetBorderColour(inspection.ObservationReadings.ScallopL,'S')"  class="input-readings" type="number" formControlName="ScallopLeft"  [(ngModel)]="inspection.ObservationReadings.ScallopL"/> {{measurementUnit}}
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.ScallopLComment !== ''  || inspection.ObservationComments.ScallopLComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.ScallopLComment == '' ? 'Add Comment' :inspection.ObservationComments.ScallopLComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.ScallopLComment!== null  &&inspection.ObservationComments.ScallopLComment!== undefined && inspection.ObservationComments.ScallopLComment !== ' '&& inspection.ObservationComments.ScallopLComment !== ''"
                      (click)="openConditionComment(Condition.ScallopL, inspection.ObservationComments.ScallopLComment)">
                      chat_bubble{{ inspection.ObservationComments.ScallopLComment!== null  &&inspection.ObservationComments.ScallopLComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.ScallopLImage" [isImagePathRequired]="true" 
                      [condition]="Condition.ScallopL" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.ScallopL, $event)"></condition-photo>

                    </div>
                    <div class="condition">
                      <span class="condition__side">R</span>
                      <span class="condition__reading">
                        <div >
                          <input [ngClass]="GetBorderColour(inspection.ObservationReadings.ScallopR,'S')" class="input-readings" type="number" formControlName="ScallopRight"  [(ngModel)]="inspection.ObservationReadings.ScallopR" /> {{measurementUnit}}
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.ScallopRComment !== ''  || inspection.ObservationComments.ScallopRComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.ScallopRComment == '' ? 'Add Comment' :inspection.ObservationComments.ScallopRComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.ScallopRComment!== null  &&inspection.ObservationComments.ScallopRComment!== undefined && inspection.ObservationComments.ScallopRComment !== ' '&& inspection.ObservationComments.ScallopRComment !== ''"
                      (click)="openConditionComment(Condition.ScallopR, inspection.ObservationComments.ScallopRComment)">
                      chat_bubble{{ inspection.ObservationComments.ScallopRComment!== null  &&inspection.ObservationComments.ScallopRComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.ScallopRImage" [isImagePathRequired]="true" 
                      [condition]="Condition.ScallopR" [inspectionDraftId]= "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.ScallopR, $event)"></condition-photo>

                    </div>
                  </item>

                  <item *ngIf="visibility('DJ') && showDryJoints" style="margin-left: 15px;margin-right: 0px;" [label]="translate('Dry Joints')"  [loading]="overviewIsLoading">
                    <div class="condition">
                      <span class="condition__side">L</span>
                      <span class="condition__reading">
                        <div>
                          <input  class="input-readings"  type="number" formControlName="DryJointLeft"  [(ngModel)]="inspection.ObservationReadings.NoDryJointsL" />
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.NoDryJointsLComment !== ''  || inspection.ObservationComments.NoDryJointsLComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.NoDryJointsLComment == '' ? 'Add Comment' :inspection.ObservationComments.NoDryJointsLComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.NoDryJointsLComment!== null  &&inspection.ObservationComments.NoDryJointsLComment!== undefined && inspection.ObservationComments.NoDryJointsLComment !== ' '&& inspection.ObservationComments.NoDryJointsLComment !== ''"
                      (click)="openConditionComment(Condition.DryJointsL, inspection.ObservationComments.NoDryJointsLComment)">
                      chat_bubble{{ inspection.ObservationComments.NoDryJointsLComment!== null  &&inspection.ObservationComments.NoDryJointsLComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.NoDryJointsLImage" [isImagePathRequired]="true" 
                      [condition]="Condition.DryJointsL" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.DryJointsL, $event)"></condition-photo>
                    </div>
                    <div class="condition">
                      <span class="condition__side">R</span>
                      <span class="condition__reading">
                        <div>
                          <input class="input-readings" type="number" formControlName="DryJointRight"  [(ngModel)]="inspection.ObservationReadings.NoDryJointsR" />
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.NoDryJointsRComment != '' || inspection.ObservationComments.NoDryJointsRComment != spaceComment "
                      [matTooltip]="inspection.ObservationComments.NoDryJointsRComment == '' ? 'Add Comment' :inspection.ObservationComments.NoDryJointsRComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.NoDryJointsRComment!== null  &&inspection.ObservationComments.NoDryJointsRComment!== undefined&& inspection.ObservationComments.NoDryJointsRComment !== ' '&& inspection.ObservationComments.NoDryJointsRComment !== ''"
                      (click)="openConditionComment(Condition.DryJointsR, inspection.ObservationComments.NoDryJointsRComment)">
                      chat_bubble{{ inspection.ObservationComments.NoDryJointsRComment!== null  &&inspection.ObservationComments.NoDryJointsRComment!== undefined ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.NoDryJointsRImage" [isImagePathRequired]="true" 
                      [condition]="Condition.DryJointsR" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.DryJointsR, $event)"></condition-photo>

                    </div>
                  </item>

                  <item *ngIf="isBasicUser==1 && visibility('L') && showNumberOfLinks"  style="margin-left: 15px;margin-right: 0px;" [label]="translate('# of Links')"  [loading]="overviewIsLoading" >
                    <div class="condition">
                      <span class="condition__side">L</span>
                      <span class="condition__reading">
                        <div>
                          <input  class="input-readings"  type="number" formControlName="LinkNoLeft" onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="inspection.ObservationReadings.LinkNoL" />
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.LinkNoLComment !== ''  || inspection.ObservationComments.LinkNoLComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.LinkNoLComment == '' ? 'Add Comment' :inspection.ObservationComments.LinkNoLComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.LinkNoLComment!== null  &&inspection.ObservationComments.LinkNoLComment!== undefined && inspection.ObservationComments.LinkNoLComment !== ' '&& inspection.ObservationComments.LinkNoLComment !== ''"
                      (click)="openConditionComment(Condition.LinkNoL, inspection.ObservationComments.LinkNoLComment)">
                      chat_bubble{{ inspection.ObservationComments.LinkNoLComment!== null  &&inspection.ObservationComments.LinkNoLComment!== undefined &&inspection.ObservationComments.LinkNoLComment!== ' ' ? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.LinkNoLImage" [isImagePathRequired]="true" 
                      [condition]="Condition.LinkNoL" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.LinkNoL, $event)"></condition-photo>

                    </div>
                    <div class="condition">
                      <span class="condition__side">R</span>
                      <span class="condition__reading">
                        <div>
                          <input  class="input-readings"  type="number" formControlName="LinkNoRight" onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="inspection.ObservationReadings.LinkNoR" />
                        </div>
                      </span>
                      <i *ngIf="inspection.ObservationComments.LinkNoRComment !== ''  || inspection.ObservationComments.LinkNoRComment !== spaceComment "
                      [matTooltip]="inspection.ObservationComments.LinkNoRComment == '' ? 'Add Comment' :inspection.ObservationComments.LinkNoRComment"
                      class="material-icons condition__icon" [class.has-comment]=" inspection.ObservationComments.LinkNoRComment!== null  &&inspection.ObservationComments.LinkNoRComment!== undefined && inspection.ObservationComments.LinkNoRComment !== ' '&& inspection.ObservationComments.LinkNoRComment !== ''"
                      (click)="openConditionComment(Condition.LinkNoR, inspection.ObservationComments.LinkNoRComment)">
                      chat_bubble{{ inspection.ObservationComments.LinkNoRComment!== null  &&inspection.ObservationComments.LinkNoRComment!== undefined &&inspection.ObservationComments.LinkNoLComment!== ' '? '' : '_outline'}}
                    </i>
                    <condition-photo  [photo]="inspection.ObservationImages.LinkNoRImage" [isImagePathRequired]="true" 
                      [condition]="Condition.LinkNoR" [inspectionDraftId] = "inspection.InspectionId" [equipmentId] ="equipmentId" (photoChange)="reloadObservations(Condition.LinkNoR, $event)"></condition-photo>

                    </div>
                  </item>
                </item-group>
                <div *ngIf="!showScallop && !showCannonExt && !showTrackSag && !showDryJoints && !showNumberOfLinks" style="padding: 20px;"><span  > {{ "No Observations active for this family" | translate | async }}</span></div>
              </div>
             
              </div>
          </div>

          <div class="fix-control-area">
            <span class="step-validation-text"  *ngIf="stepOneSubmitted && showWaring">
            <span style="color: orange">  <b>{{ 'Warning' | translate | async }} : </b> {{ 'You are currently missing the' | translate | async }} {{warningMessage}} measurement.</span>
            </span>
            <button style="float:right;" matStepperNext mat-raised-button color="warn" (click)="nextStep(0)" [disabled]= "GeneralInfoGroup?.invalid || overviewIsLoading  || !inited || loadingEquipment" >
              {{ translate("Next") }}
              <i class="material-icons"> keyboard_arrow_right</i>
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ "Left Side Components" | translate | async }}</ng-template>
        <div *ngIf="isBogieDataLoaded">
        <app-inspection-systems [impact]="inspection.UnderfootConditions.Impact" [smuReading]="inspection.SMUReading" [ShowHideCRoller]="equipmentDetails.ShowHideCRoller"
         [hidden] ="!stepOneSubmitted"  #LeftChain [inspectionDraftId]="inpsectionDraftId" [side]="1" [systemType] ="1" [FamilyName]="FamilyName"
         [FamilyImage_Chain]="FamilyImage_Chain" [EvalautionRange]="EvalautionRange" [isRSH]="equipmentDetails.ShowPropelHrsPerc" [pmuReading]="inspection.PMUReading"
                                [totalInspDistance]="totalInspDistance" [EnableDistTravelledTracking]="equipmentDetails.EnableDistTravelledTracking"
                                [ShowCannonType]="equipmentDetails.EnableCannonType" [ShowFrameConfigurtaion]="equipmentDetails.EnableFrameConfiguration"
                                [EnableBogieShim]="equipmentDetails.EnableBogieShim" (childSystemUpdated)="childSystemUpdated($event, 1, 1)" (addImagesSystem)="addImagesSystem($event)"
                                [InspId]="inspectionId" [uom]="userUOM"
                                > </app-inspection-systems>
                             
         <app-inspection-systems [impact]="inspection.UnderfootConditions.Impact" [smuReading]="inspection.SMUReading"  [ShowHideCRoller]="equipmentDetails.ShowHideCRoller"
         [hidden] ="!stepOneSubmitted"  #LeftFrame [inspectionDraftId]="inpsectionDraftId" [side]="1" [systemType] ="2" [FamilyName]="FamilyName"
          [FamilyImage_Frame]="FamilyImage_Frame" [EvalautionRange]="EvalautionRange" [isRSH]="equipmentDetails.ShowPropelHrsPerc" [pmuReading]="inspection.PMUReading"
                                 [totalInspDistance]="totalInspDistance" [EnableDistTravelledTracking]="equipmentDetails.EnableDistTravelledTracking"
                                 [BogieShimLeft]="inspection.BogieShimLeft"  [BogieShimRight]="inspection.BogieShimRight"
                                 [ShowCannonType]="equipmentDetails.EnableCannonType" [ShowFrameConfigurtaion]="equipmentDetails.EnableFrameConfiguration"
                                [EnableBogieShim]="equipmentDetails.EnableBogieShim" (childSystemUpdated)="childSystemUpdated($event, 1, 2)" [InspId]="inspectionId" (addImagesSystem)="addImagesSystem($event)"
                                [uom]="userUOM"
                                 > </app-inspection-systems>
         </div>
        <div class="fix-control-area">
             <span class="step-validation-text"  *ngIf="stepOneSubmitted &&showWaring">
                <span style="color: orange"> <b>{{ 'Warning' | translate | async }} : </b> {{ 'You are currently missing the' | translate | async }} {{warningMessage}} measurement.</span>
            </span>

            <button style="float:right;" matStepperNext mat-raised-button color="warn" (click)="nextStep(1)" >
              {{ translate("Next") }} <i class="material-icons"> keyboard_arrow_right</i></button>
            <button style="float:right;" mat-button matStepperPrevious color="grey" (click)="ShowWarning()">
                <i class="material-icons"> keyboard_arrow_left</i>  {{ translate("Back") }}</button>
          </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>{{ "Right Side Components" | translate | async }}</ng-template>
        <div *ngIf="isBogieDataLoaded">
          <app-inspection-systems [EvalautionRange]="EvalautionRange"[impact]="inspection.UnderfootConditions.Impact" [smuReading]="inspection.SMUReading"
                                [pmuReading]="inspection.PMUReading"[hidden] ="!stepOneSubmitted"  #RightChain [inspectionDraftId]="inpsectionDraftId"
                                [side]="2" [systemType]="1"  [FamilyImage_Chain]="FamilyImage_Chain" [isRSH]="equipmentDetails.ShowPropelHrsPerc"
                                [ShowHideCRoller]="equipmentDetails.ShowHideCRoller" [totalInspDistance]="totalInspDistance" [EnableDistTravelledTracking]="equipmentDetails.EnableDistTravelledTracking"
                                [ShowCannonType]="equipmentDetails.EnableCannonType" [ShowFrameConfigurtaion]="equipmentDetails.EnableFrameConfiguration" [uom]="userUOM"
                                [EnableBogieShim]="equipmentDetails.EnableBogieShim" (childSystemUpdated)="childSystemUpdated($event, 2, 1)" [InspId]="inspectionId"> </app-inspection-systems>
          <app-inspection-systems [EvalautionRange]="EvalautionRange"[impact]="inspection.UnderfootConditions.Impact" [smuReading]="inspection.SMUReading" [pmuReading]="inspection.PMUReading"
                                [hidden] ="!stepOneSubmitted"  #RightFrame [inspectionDraftId]="inpsectionDraftId"  [side]="2" [systemType]="2"  [FamilyImage_Frame]="FamilyImage_Frame"
                                [isRSH]="equipmentDetails.ShowPropelHrsPerc"  [ShowHideCRoller]="equipmentDetails.ShowHideCRoller" [totalInspDistance]="totalInspDistance" [EnableDistTravelledTracking]="equipmentDetails.EnableDistTravelledTracking"
                                [BogieShimRight]="inspection.BogieShimRight" [BogieShimLeft]="inspection.BogieShimLeft" [ShowCannonType]="equipmentDetails.EnableCannonType" [ShowFrameConfigurtaion]="equipmentDetails.EnableFrameConfiguration"
                                [EnableBogieShim]="equipmentDetails.EnableBogieShim" (childSystemUpdated)="childSystemUpdated($event, 2, 2)" [InspId]="inspectionId" [uom]="userUOM"
                                > </app-inspection-systems>
        </div>
        <div class="fix-control-area">

            <span class="step-validation-text"  *ngIf="stepOneSubmitted &&showWaring">
              <span style="color: orange">  <b>{{ 'Warning' | translate | async }} : </b> {{ 'You are currently missing the' | translate | async }} {{warningMessage}} measurement.</span>
            </span>
            <button style="float:right;" matStepperNext mat-raised-button color="warn" (click)="nextStep(2)" >
              {{ translate("Next") }}   <i class="material-icons"> keyboard_arrow_right</i></button>
            <button style="float:right;" mat-button matStepperPrevious color="grey" (click)="ShowWarning()">
                <i class="material-icons"> keyboard_arrow_left</i>  {{ translate("Back") }}</button>
          </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ 'Additional Observations' | translate | async }}</ng-template>

        <div class="panel observation-panel">
          <div class="panel__header">
            <span class="panel__header__title">
              {{ 'Additional Observation Lists' | translate | async }}
            </span>
          </div>
          <div>
            <panel class="no-padding table-panel">
              <table class="table table--full-width table--striped table--hover" >
                <thead>
                  <tr>
                    <th>{{'Title' | translate | async}}</th>
                    <th>{{'Answer' | translate | async}}</th>
                    <th>{{'Image' | translate | async}}</th>
                    <th>{{'Comment' | translate | async}}</th>
                    <th>{{'Delete' | translate | async}}</th>

                    <th> <button mat-raised-button color="warn" (click)="AddNewObservationList()">  {{"Add Observations"|translate|async}}</button></th>
                  </tr>
                </thead>
                <tbody  *ngIf="inspection.AdditionalObservationDrafts?.length >0">
                  <tr *ngFor="let ob of  inspection.AdditionalObservationDrafts">
                    <td [@fadeIn] [attr.title]="ob?.Title">{{ ob.Title }}</td>

                    <td>

                      <div *ngIf="ob.QuestionTypeId==0" class="upload-container">
                       
                      </div>
                      <div *ngIf="ob.HasAnswerd==false && ob.QuestionTypeId>0" class="upload-container" (click)="AnswerAdditonalObs(ob)" title="Add Answer">
                        <i class="material-icons upload-container__icon">
                          comment
                        </i>
                      </div>
      
                      <div style="display: flex;">
                        <div *ngIf="ob.HasAnswerd==true  && ob.QuestionTypeId>0" class="upload-container" (click)="AnswerAdditonalObs(ob)" title="Edit Answer">
                          <i class="material-icons upload-container__icon"  style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;" >
                            comment
                          </i>
                        </div>
  
  
                        <div style="display: flex; flex-direction: row;height: fit-content;align-self: center;" *ngIf="ob.QuestionTypeId==5 && ob.wornPercent!=null && ob.HasAnswerd==true">
                    <span class="Eval-{{ ob.wornPercent | wornPercentageToEval}}"
                        style="margin-right: 0px;">
                        <div>{{ob.wornPercent}}%</div>
                    </span>
                </div>
                      </div>
                      
                      
                    </td>
                    <td>
                      <!-- <upload-photo *ngIf="ob.Image == ''  || ob.Image == null" [ObservationListId]="ob.Id"   (onPhotoUpload)="reloadAdditionalObservationPhoto(ob)" [comingFrom]="popupEndPoint"   [isCreatingNewInspection] ="true" [inspectionId]="inspection.InspectionId" ></upload-photo>

                      <i  (click)="viewAdditionalObservationListPhoto(ob)"style="border: 1px solid #2196f3; color: #2196f3; padding: 8px;"*ngIf="ob.Image != '' && ob.Image !== null" class="material-icons upload-container__icon" matTooltip="View/Edit Photo">add_a_photo</i> -->
                      

                      <upload-photo  [ObservationListId]="ob.Id"   (onPhotoUpload)="reloadAdditionalObservationPhoto(ob, $event)" [comingFrom]="popupEndPoint"   [isCreatingNewInspection] ="true" [inspectionId]="inspection.InspectionId" [imageUrl]="true"></upload-photo>

                      <i  *ngFor="let photo of ob.ObsImages" (click)="viewAdditionalObservationListPhoto(ob,photo)"style="border: 1px solid #2196f3; color: #2196f3; padding: 8px;"
                      class="material-icons upload-container__icon" matTooltip="View/Edit Photo">add_a_photo</i>
                    </td>
                    <td>
                        <div class='observation-image' *ngIf="(ob.Comment === ''  || ob.Comment === null || ob.Comment === undefined)"  (click)="AddObservationListComment(ob)" title="{{'Add Comment' | translate | async}}">
                            <i class="material-icons observation-image__icon">
                              message
                            </i>
                        </div>
                        <div  *ngIf="ob.Comment !== ''  && ob.Comment !== null && ob.Comment !== undefined"   (click)="AddObservationListComment(ob)">
                          <i   class="material-icons observation-image__icon" style ="border: 1px solid #2196f3;color: #2196f3; padding: 8px;" matTooltip="{{ob.Comment}}">
                            message
                          </i>
                      </div>
                        
                        <!-- <span class="observation-comment" title="{{ob.Comment}}" *ngIf="ob.Comment !== ''  && ob.Comment !== null && ob.Comment !== undefined" (click)="AddObservationListComment(ob)">
                            {{ob.Comment | slice:0:30}} {{ob.Comment?.length>30 ? '...' : ''}}
                        </span> -->
                       </td>

                       <td>
                        <i   class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;cursor: pointer;"  title="Delete Additional Observation" (click)="OpenDeleteAdditionalObs(ob.Id, ob.Title)" >
                          delete
                        </i>
                      </td>
                       <td></td>
                  </tr>
                </tbody>
                <div *ngIf="inspection.AdditionalObservationDrafts?.length === 0">
                  {{ "Currently there is no observation list configured for this equipment" | translate | async }}
                </div>
              </table>
            </panel>
          </div>
        </div>






        <div class="fix-control-area">
             <span class="step-validation-text"  *ngIf="stepOneSubmitted &&showWaring">
                <span style="color: orange"> <b> {{ 'Warning' | translate | async }}: </b> {{ 'You are currently missing the' | translate | async }} {{warningMessage}}   {{ 'measurement' | translate | async }}. </span>
            </span>

            <button style="float:right;" matStepperNext mat-raised-button color="warn" (click)="nextStep(3)" >
              {{ translate("Next") }} <i class="material-icons"> keyboard_arrow_right</i></button>
            <button style="float:right;" mat-button matStepperPrevious color="grey" (click)="ShowWarning()">
                <i class="material-icons"> keyboard_arrow_left</i>  {{ translate("Back") }}</button>
          </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ "Review & Save" | translate | async }}</ng-template>
        <div class="flex flex-containers">
          <div class="panel info-panels ">
            <div class="panel__header">
              <span class="panel__header__title">
                {{ "Left Chain" | translate | async }}
              </span>
            </div>
            <div>
                <app-inspection-review [EvalautionRange]="EvalautionRange" [hidden] ="!stepOneSubmitted"  #LeftChainReview [inspectionDraftId]="inpsectionDraftId"  [side]="1" [systemType]="1" [totalInspDistance]="totalInspDistance"
                [system]="inspection.SystemDataChainLeft"></app-inspection-review>
            </div>
          </div>

          <div class="panel  info-panels">
            <div class="panel__header">
              <span class="panel__header__title">
                {{ "Right Chain" | translate | async }}
              </span>
            </div>
            <div>
                <app-inspection-review [EvalautionRange]="EvalautionRange" [hidden] ="!stepOneSubmitted" #RightChainReview [inspectionDraftId]="inpsectionDraftId"  [side]="2" [systemType]="1" [totalInspDistance]="totalInspDistance"
                [system]="inspection.SystemDataChainRight"></app-inspection-review>
            </div>
        </div>
      </div>
        <div class="flex flex-containers">
          <div class="panel info-panels ">
            <div class="panel__header">
              <span class="panel__header__title">
                {{ "Left Frame" | translate | async }}
              </span>
            </div>
            <div>
                <app-inspection-review [EvalautionRange]="EvalautionRange" [hidden] ="!stepOneSubmitted" #LeftFrameReview [inspectionDraftId]="inpsectionDraftId"  [side]="1" [systemType]="2" [totalInspDistance]="totalInspDistance"
                [system]="inspection.SystemDataFrameLeft"></app-inspection-review>
            </div>

          </div>

          <div class="panel  info-panels">
            <div class="panel__header">
              <span class="panel__header__title">
                {{ "Right Frame" | translate | async }}
              </span>
            </div>
            <div>
                <app-inspection-review  [EvalautionRange]="EvalautionRange" [hidden] ="!stepOneSubmitted" #RightFrameReview [inspectionDraftId]="inpsectionDraftId"  [side]="2" [systemType]="2" [totalInspDistance]="totalInspDistance"
                [system]="inspection.SystemDataFrameRight"></app-inspection-review>
            </div>
          </div>
        </div>


        <div class="fix-control-area">
            <span class="step-validation-text"  *ngIf="stepOneSubmitted && showWaring">
              <span style="color: orange">  <b>{{ 'Warning' | translate | async }} : </b> {{ 'You are currently missing the' | translate | async }} {{warningMessage}} measurement.</span>
            </span>

            <button *ngIf="inspectionId==0 && isBasicUser!=1" style="float:right;" matStepperNext mat-raised-button color="warn" [disabled]="submitted"  [class.loading]="saving"  (click)="saveInspectionAndSendReport()" >
              {{ translate("Save And Send Report") }} <i class="material-icons"> done_outline </i>  </button>

            <button style="float:right; margin-right: 1%;" matStepperNext mat-raised-button color="warn" [disabled]="submitted"  [class.loading]="saving"  (click)="saveInspectionSp()" >
              {{ translate("Save And Interpret") }} <i class="material-icons"> done_outline </i>  </button>

              
            <button style="float:right;" mat-button matStepperPrevious color="grey" (click)="ShowWarning()" >
                <i class="material-icons" > keyboard_arrow_left</i>  {{ translate("Back") }}</button>
          </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
